import type { ProductPosition } from '@/api/products';

/** The slice of a stored position this rule reads. */
export interface StoredPositionState {
  json?: { objects?: unknown[] } | null;
  productPositionId?: string | null;
}

/**
 * Which of the offered positions carry artwork in the stored canvas state.
 *
 * One rule for everyone who asks — what unlocks the purchase, what the
 * quote is built from and what the cart button decides on: a position
 * counts when its stored canvas has objects, and only when the stored entry
 * belongs to this product. masterPositions is slug-keyed across products; a
 * resumed or stale entry that records a different ProductPosition must not
 * count as this product's decoration. Entries without a recorded id pass —
 * rejecting them would lock the checkout for legitimate sessions.
 */
export function positionsWithArtwork(
  positions: readonly ProductPosition[],
  stored: Record<string, StoredPositionState | undefined>
): ProductPosition[] {
  return positions.filter((position) => {
    const state = stored[position.slug];
    if ((state?.json?.objects?.length ?? 0) === 0) return false;
    return !state?.productPositionId || state.productPositionId === position.id;
  });
}
